import spinner from './spinner-small.gif';

const SmallLoader = ({ isLoading, size = 20, classes = '' }) => isLoading && <img src={spinner} alt="spinner" width={size} className={classes} />;

export default SmallLoader;
